import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

const useSearchParamSessionValue = (key, defaultValue, storageKey = false) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const sessionKey = storageKey || key
  const param = searchParams.get(key)
  const sessionValue = sessionStorage.getItem(sessionKey)
  const value = param !== null ? param : sessionValue !== null ? sessionValue : defaultValue

  const setValue = (newValue) => {
    sessionStorage.setItem(sessionKey, newValue)
    setSearchParams(
      (prev) => {
        prev.set(key, newValue)
        return prev
      },
      { replace: true }
    )
  }

  const removeParam = () => {
    sessionStorage.removeItem(sessionKey)
    setSearchParams(
      (prev) => {
        prev.delete(key)
        return prev
      },
      { replace: true }
    )
  }

  useEffect(() => {
    if (value === 'null') setValue('')
  }, [value])

  return [value, setValue, removeParam]
}

export default useSearchParamSessionValue
